"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Dispatch Plugin
 *
 * generates dispatch[modelName][actionName]
 */
var dispatchPlugin = {
    exposed: {
        // required as a placeholder for store.dispatch
        storeDispatch: function (action, state) {
            console.warn('Warning: store not yet loaded');
        },
        storeGetState: function () {
            console.warn('Warning: store not yet loaded');
        },
        /**
         * dispatch
         *
         * both a function (dispatch) and an object (dispatch[modelName][actionName])
         * @param action T.Action
         */
        dispatch: function (action) {
            return this.storeDispatch(action);
        },
        /**
         * createDispatcher
         *
         * genereates an action creator for a given model & reducer
         * @param modelName string
         * @param reducerName string
         */
        createDispatcher: function (modelName, reducerName) {
            var _this = this;
            return function (payload, meta) { return __awaiter(_this, void 0, void 0, function () {
                var action;
                return __generator(this, function (_a) {
                    action = { type: modelName + "/" + reducerName };
                    if (typeof payload !== 'undefined') {
                        action.payload = payload;
                    }
                    if (typeof meta !== 'undefined') {
                        action.meta = meta;
                    }
                    return [2 /*return*/, this.dispatch(action)];
                });
            }); };
        },
    },
    onStoreCreated: function (store) {
        this.storeDispatch = store.dispatch;
        this.storeGetState = store.getState;
        return { dispatch: this.dispatch };
    },
    // generate action creators for all model.reducers
    onModel: function (model) {
        this.dispatch[model.name] = {};
        if (!model.reducers) {
            return;
        }
        for (var _i = 0, _a = Object.keys(model.reducers); _i < _a.length; _i++) {
            var reducerName = _a[_i];
            this.validate([
                [
                    !!reducerName.match(/\/.+\//),
                    "Invalid reducer name (" + model.name + "/" + reducerName + ")",
                ],
                [
                    typeof model.reducers[reducerName] !== 'function',
                    "Invalid reducer (" + model.name + "/" + reducerName + "). Must be a function",
                ],
            ]);
            this.dispatch[model.name][reducerName] = this.createDispatcher.apply(this, [model.name, reducerName]);
        }
    },
};
exports.default = dispatchPlugin;
//# sourceMappingURL=dispatch.js.map